var RegisterComponent = /** @class */ (function () {
    function RegisterComponent() {
    }
    return RegisterComponent;
}());
export { RegisterComponent };
